import Card from "components/card";
import useCourierTable from "./hooks/useTable";
import CardMenu from "components/card/CardMenu";
import CourierProfile from "./components/CourierProfile";
import ModalDeleteConfirmation from "components/modals/components/DeleteConfirmation";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { useDisclosure } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

const CourierDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { handleDeleteCourier } = useCourierTable();

  return (
    <>
      <Card extra={"w-full h-full px-6 pb-3 mt-3"}>
        <header className="relative flex items-center justify-between pt-4">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            Detail Kurir
          </div>
          <CardMenu
            children={
              <>
                <Link
                  to={`/admin/couriers/edit/${id}`}
                  className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-brand-500 hover:font-medium hover:text-brand-600"
                >
                  <span>
                    <AiOutlineEdit />
                  </span>
                  Edit
                </Link>
                <button
                  className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-red-500 hover:font-medium hover:text-red-600"
                  onClick={() => onOpen()}
                >
                  <span>
                    <AiOutlineDelete />
                  </span>
                  Hapus
                </button>
              </>
            }
          />
        </header>

        <CourierProfile />
      </Card>
      {createPortal(
        <ModalDeleteConfirmation
          isOpen={isOpen}
          onClose={onClose}
          onDelete={handleDeleteCourier}
          itemId={parseInt(id)}
        />,
        document.body
      )}
    </>
  );
};

export default CourierDetail;
